"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jexlStrings_1 = require("../../../util/jexlStrings");
var SerializableFilterChain = /*#__PURE__*/function () {
  function SerializableFilterChain(_ref) {
    var _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters;
    _classCallCheck(this, SerializableFilterChain);
    this.filterChain = filters.map(function (inputFilter) {
      if (typeof inputFilter === 'string') {
        var expr = (0, jexlStrings_1.stringToJexlExpression)(inputFilter);
        return {
          expr: expr,
          string: inputFilter
        };
      }
      throw new Error("invalid inputFilter string \"".concat(inputFilter, "\""));
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _createClass(SerializableFilterChain, [{
    key: "passes",
    value: function passes() {
      for (var i = 0; i < this.filterChain.length; i += 1) {
        if (
        // @ts-ignore
        !this.filterChain[i].expr.evalSync({
          feature: arguments.length <= 0 ? undefined : arguments[0]
        })) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        filters: this.filterChain.map(function (f) {
          return f.string;
        })
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(json) {
      return new SerializableFilterChain(json);
    }
  }]);
  return SerializableFilterChain;
}();
exports.default = SerializableFilterChain;